import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp, MaskedLines } from "@/components/Reveal";

const LOSSES = [
  "You avoid looking in mirrors",
  "You cancel plans when a breakout appears",
  "You have lost confidence in photos",
  "You feel shy meeting new people",
  "You stop raising your hand in class or meetings",
  "You spend mornings covering up before you can face the day",
  "You have tried countless products with no lasting result",
];

export default function Struggling() {
  return (
    <div data-testid="page-struggling">
      <section className="mx-auto max-w-[88rem] px-5 sm:px-10 pt-[8.5rem] lg:pt-[10.5rem] pb-20 lg:pb-28">
        <div className="max-w-3xl">
          <FadeUp>
            <p className="text-xs uppercase tracking-[0.26em] text-[#4A6B56] mb-6">
              You're not alone in this
            </p>
          </FadeUp>
          <h1 className="font-display text-[clamp(2.2rem,3.8vw,3.2rem)] leading-[1.08] text-[#1B4332]">
            <MaskedLines onView lines={["Are you struggling", "with acne?"]} />
          </h1>
          <FadeUp delay={0.2}>
            <p className="mt-6 max-w-2xl text-lg text-[#4A6B56] leading-relaxed">
              If breakouts keep coming back, you already know it's more than skin. It follows you
              into your day, your mood, and the moments you wish you felt more like yourself.
              Whatever you're feeling, it's valid — and you're not the only one.
            </p>
          </FadeUp>
        </div>

        <div className="mt-14 lg:mt-16 space-y-5 max-w-3xl">
          {LOSSES.map((loss, i) => (
            <FadeUp key={loss} delay={i * 0.05}>
              <div data-testid={`struggle-loss-${i}`} className="group flex items-baseline gap-5 sm:gap-7">
                <span aria-hidden="true" className="text-xl text-[#4A6B56] shrink-0">—</span>
                <p className="font-display text-[clamp(1.2rem,1.8vw,1.5rem)] leading-snug text-[#1B4332] transition-transform duration-500 group-hover:translate-x-2">
                  {loss}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[88rem] px-5 sm:px-10 pb-24 lg:pb-36">
        <FadeUp>
          <div className="rounded-2xl bg-[#F1F8F2] border border-[#D1E2D6]/60 p-10 sm:p-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
            <h2 className="font-display text-[clamp(1.7rem,2.8vw,2.4rem)] leading-[1.15] text-[#1B4332] max-w-xl">
              It's not your fault. And it's not forever.
            </h2>
            <Link
              to="/results"
              data-testid="struggle-results-link"
              className="group inline-flex items-center gap-3 rounded-full bg-[#1B4332] text-[#E8F3EB] px-8 h-13 min-h-[3.25rem] font-medium hover:bg-[#2D5A44] transition-colors duration-300 shrink-0"
            >
              See the results
              <ArrowUpRight
                size={17}
                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </Link>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
